import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom'; 
import { Link as LinkS } from 'react-scroll';

export const Nav = styled.nav`
    background: ${({scrollNav, lightTheme}) => (scrollNav ? 'rgba(0,0,0,0.7)' : lightTheme ? 'rgba(255,255,255,0.7)' : 'transparent')};
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    height: 80px;
    margin-top: ${({margin}) => (margin ? '0px' : '-80px')};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 100;
    transition: all 0.3s ease-in-out;
    border-bottom: 1px solid ${({scrollNav}) => (scrollNav ? 'rgba(255, 255, 255, 0.1)' : 'transparent')};

    @media screen and (max-width: 960px) {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
`

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 30px;
    max-width: 1400px;

    @media screen and (max-width: 768px) {
        padding: 0 20px;
    }

    @media screen and (max-width: 480px) {
        padding: 0 20px;
    }
`

export const NavLogo = styled(LinkR)`
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 24px;
    text-decoration: none;
`

export const MobileIcon = styled.div`
    display: none;
    
    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
        color: ${({scrollNav, lightTheme}) => (scrollNav ? '#fff' : lightTheme ? '#000' : '#fff')};
        transition: color 0.2s ease-in-out;

        &:hover {
            color: ${({lightTheme}) => (lightTheme ? '#38A7BA' : '#ccc')};
        }
    }
`

export const NavMenu = styled.ul`
    display: ${({type}) => (type ? 'flex' : 'none')};
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavItem = styled.li`
    height: 80px;
`

export const NavLinks = styled(LinkS)`
    color: ${({scrollNav, lightTheme}) => (scrollNav ? '#fff' : lightTheme ? '#000' : '#fff')};
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1.5rem;
    height: 100%;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 2px;
        background: ${({scrollNav, lightTheme}) => (scrollNav ? 'rgba(255, 255, 255, 0.8)' : lightTheme ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)')};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &.active {
        color: ${({scrollNav, lightTheme}) => (scrollNav ? '#fff' : lightTheme ? '#000' : '#fff')};
        
        &:after {
            width: 24px;
        }
    }

    &:hover {
        color: ${({scrollNav, lightTheme}) => (scrollNav ? 'rgba(255, 255, 255, 0.9)' : lightTheme ? '#38A7BA' : 'rgba(255, 255, 255, 0.9)')};
        
        &:after {
            width: 24px;
        }
    }
`

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    font-weight: 500;
    /* letter-spacing: 1px; */

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavBtnLink = styled(LinkS)`
    border-radius: 8px;
    background-color: ${({scrollNav, lightTheme}) => (scrollNav ? '#38A7BA' : lightTheme ? '#38A7BA' : 'rgba(255, 255, 255, 0.95)')};
    white-space: nowrap;
    padding: 10px 20px;
    color: ${({scrollNav, lightTheme}) => (scrollNav ? '#fff' : lightTheme ? '#fff' : '#010606')};
    font-size: 16px;
    font-weight: 500;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    letter-spacing: 0.2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid transparent;

    &:hover {
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        background: #fff;
        color: #010606;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-color: rgba(255, 255, 255, 0.2);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
`

export const Imgs = styled.embed`
    width: 14vw;
    height: auto;

    @media screen and (max-width: 768px){
        width: 25vw;
        height: auto;
    }
    
    @media screen and (max-width: 490px){
        width: 37vw;
        height: auto;
    }

    @media screen and (max-width: 280px){
        width: 42vw;
        height: auto;
    }
`

export const StoreItem = styled(LinkR)`
    display: flex;
    justify-content: center;
    width: 140px;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.05);
    }
`;

export const StoreImg = styled.img`
    width: 100%;
    height: auto;
`;

export const StoreButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: center;
    align-items: center;
`;